export default "__VITE_ASSET__BWHOjszS__"